"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryString = void 0;
const filter_types_1 = require("./filter-types");
const sort_types_1 = require("./sort-types");
const date_format_1 = require("./date-format");
/**
 * @description
 * Transform a CiPortalAPi Query Object into a CiPortal Query String
 *
 * @param query
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function queryString(options) {
    const { includeDeleted, sorts, filters, dateFormat, pagelength = 15, page = 1, } = options.query;
    const queryParams = Object.assign(Object.assign(Object.assign(Object.assign({ 'pagelength': pagelength, 'page': page }, (dateFormat ? date_format_1.dateFormatToQueryString(dateFormat) : {})), (sorts ? sort_types_1.sortsToQueryString(sorts) : {})), (filters ? filter_types_1.filtersToQueryString(filters) : {})), (includeDeleted === true ? { deleted: true } : {}));
    let qs = '';
    Object
        .entries(queryParams)
        .forEach(([f, v]) => { qs += `${(qs ? '&' : '')}${f}=${v}`; });
    options
        .relations
        .filter((inp) => (inp != null))
        .forEach(relation => { qs += `${qs ? '&' : ''}with[]=${encodeURIComponent(relation)}`; });
    if (options.extra)
        qs += `${(qs ? '&' : '')}${options.extra.map(param => encodeURIComponent(param)).join('&')}`;
    return qs;
}
exports.queryString = queryString;
